import React, {Component} from 'react'
import {v1 as uuidv1} from 'uuid'

import style from './resultPros.module.scss'

class ResultPros extends Component {
   render() {
      const {pros} = this.props
      return (
         <ul className={style.resultPros__prosList}>
            {pros.map((pro, i) => (
               <li className={style.resultPros__prosItem} key={uuidv1()}>
                     <span className={style.resultPros__prosText}>
                         <div className={style.resultPros__prosImg}>
                             <svg width='14' height='14' viewBox='0 0 14 14' fill='none'
                                  xmlns='http://www.w3.org/2000/svg'>
                                 <path
                                    d='M3.69824 12.4278C3.69824 12.3809 3.69824 12.334 3.69824 12.2871C3.69824 9.98878 3.69824 7.69048 3.69824 5.34528C3.69824 5.25148 3.74561 5.15767 3.79297 5.11076C4.69289 4.26649 5.59281 3.46912 6.49273 2.62485C7.01374 2.15581 7.29793 1.54606 7.39265 0.842499C7.44002 0.326555 7.77157 0.0451312 8.33994 0.0920352C9.14513 0.138939 9.7135 0.654883 9.90296 1.49916C10.0451 2.0151 9.99769 2.57795 9.80823 3.09389C9.66614 3.51603 9.52405 3.89126 9.33459 4.3134C9.38195 4.3134 9.42932 4.3134 9.52405 4.3134C10.5661 4.3134 11.6081 4.3134 12.6975 4.3134C13.4079 4.3134 13.9289 4.87624 13.9763 5.39219C14.071 5.95504 13.8816 6.42408 13.4079 6.79931C13.7395 7.50287 13.55 8.11262 12.9343 8.62856C13.2658 9.33212 13.0764 9.94188 12.4606 10.4578C12.6027 10.6923 12.6501 10.9738 12.6027 11.2552C12.5554 11.9118 11.9396 12.4747 11.2765 12.4747C8.76622 12.4747 6.20855 12.4747 3.69824 12.4747C3.74561 12.4278 3.74561 12.4278 3.69824 12.4278Z'
                                    fill='url(#paint0_linear_94_149)' />
                                 <defs>
                                 <linearGradient id='paint0_linear_94_149' x1='8.84911' y1='0.0869751'
                                                 x2='8.84911' y2='12.4747'
                                                 gradientUnits='userSpaceOnUse'>
                                 <stop stopColor='#72C575' />
                                 <stop offset='1' stopColor='#3BCC75' />
                                 </linearGradient>
                                 <linearGradient id='paint1_linear_94_149' x1='1.44479' y1='4.26648'
                                                 x2='1.44479' y2='13.319' gradientUnits='userSpaceOnUse'>
                                 <stop stopColor='#72C575' />
                                 <stop offset='1' stopColor='#3BCC75' />
                                 </linearGradient>
                                 </defs>
                             </svg>
                         </div>
                        {pro}
                     </span>
               </li>
            ))}
         </ul>
      )
   }
}

export default ResultPros